import React from "react";

const Plus = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 248">
      <path id="Vector 26" d="M24 12H0" stroke="#EC2526" strokeWidth="2" />
      <path
        id="Vector 27"
        d="M12 8.9407e-08L12 24"
        stroke="#EC2526"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export default Plus;
